import React from 'react';
import { Tooltip } from '@material-ui/core';

import { getShortName } from '@/utils/Util';

const BuyerActivityCard = ({ buyer, onClick }) => {
	return (
		<div
			className="single-buyer-activity shadow-4dp p-12 bg-white"
			onClick={() => onClick(buyer?.mixpanelUrl)}
			style={{ cursor: 'pointer' }}
		>
			<div className="buyer-activity-image pl-2 pt-1">
				<iframe
					src={`${buyer?.mixpanelUrl}#scrollbar=0`}
					scrolling="no"
					frameBorder="0"
					style={{ pointerEvents: 'none' }}
					title={`${buyer?.name} activity data`}
				></iframe>
			</div>
			<div className="buyer-activity-content p-2 ml-2 mt-2">
				<h3 className="semibold-14 mb-0">{buyer?.name}'s Buyer Activity</h3>
				{buyer?.brands && buyer?.brands?.length > 0 && (
					<Tooltip title={buyer?.brands?.join(', ')?.toUpperCase()}>
						<p className="regular-14 text-uppercase gray_dark_02 mb-0 mt-half">
							{getShortName(buyer?.brands?.join(', '), 44)}
						</p>
					</Tooltip>
				)}
			</div>
		</div>
	);
};

export default BuyerActivityCard;
